import React from 'react'
/**
 * [CheckButton: component to create a CheckButton with formik or just useState var]
 * @param  option string with the check option
 * @param  value useState value to compare with option
 * @param  setValue useStateSetValue
 * @param  textName Text to show in the CheckButton
 * @param  name used with formik to define the name in input
 * @param  formik optional formik to manage the data
 * @return CheckButton component
 */
const CheckButton = ({ option, value, setValue, textName, name, formik = '' }) => {

    return (
        <>
            {formik ?
                <div className={`cursor-pointer`}>
                    <input
                        name={name}
                        className={`cursor-pointer`}
                        type="radio"
                        onChange={(e) => {
                            setValue(option)
                            formik.setFieldValue(name, option)
                        }
                        }
                        value={option}
                        checked={value ===option}
                    />
                    <span
                        name={name}
                        className={`cursor-pointer`}
                        value={option}
                        onClick={() => {
                            setValue(option)
                            formik.setFieldValue(name, option)
                        }}
                    >
                        {textName}
                    </span>
                </div > :
                <div className={`cursor-pointer`}
                    onClick={() =>
                        setValue(option)
                    }>
                    <input
                        className={`cursor-pointer`}
                        type="radio"
                        onChange={e => {
                            setValue(e.target.value)
                        }}
                        value={option}
                        checked={value ===option}
                    />
                    {textName}
                </div >
            }
        </>
    )
}

export default CheckButton